<div class="container-fluid ptCustom">

    <div class="my-2">
        <a [routerLink]="['/admin-portal/chamber/chamber-perks-management']" class="text-white"><i
                class="fa-regular fa-angle-left"></i> back to all Chamber Perks</a>
    </div>

    <div class="row">

        <div class="col-lg-8 col-md-8 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Chamber Perk Information</h4>
                            <a href="javascript:void(0);" data-bs-toggle="modal" (click)="editPerk()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Entity</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{discount.companyName}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Value</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{discount.value}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Date Range</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{discount.validFromString}} until
                                                {{discount.validThroughString}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Redeemed / Limit</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{discount.limitString}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                </div>
            </div>
        </div>



    </div>

</div>